import React, { useEffect, useRef, useState } from "react";
import { Button, NavBar, Grid, Toast, Mask } from "antd-mobile";
import { APPLICATION_SCREEN, ISwitchScreenAction } from "../../App";
import RequestHelper from "../../common/RequestHelper";
import LoadingView from "../../components/LoadingView";
import { Bounce, ToastContainer, toast } from 'react-toastify';
import moment from "moment";
import { sendTelegramMessage } from "../../common/utils";
import { TELEGRAM_GROUP_ID, TELEGRAM_TOKEN_HOROSCOPE } from "../../common/Constants";

const dataListHoroscope = [
  {
    name: "Bạch Dương – Aries (21/3 – 19/4)",
    id: "bachduong",
    icon: "♈",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/bach-duong.htm"
  },
  {
    name: "Kim Ngưu – Taurus (20/4 - 20/5)",
    id: "kimnguu",
    icon: "♉",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/kim-nguu.htm"
  },
  {
    name: "Song Tử – Gemini (21/5 - 20/6)",
    id: "songtu",
    icon: "♊",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/song-tu.htm"
  },
  {
    name: "Cự Giải – Cancer (21/6 - 22/7)",
    id: "cugiai",
    icon: "♋",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/cu-giai.htm"
  },
  {
    name: "Sư Tử – Leo (23/7 - 22/8)",
    id: "sutu",
    icon: "♌",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/su-tu.htm"
  },
  {
    name: "Xử Nữ – Virgo (23/8 - 22/9)",
    id: "xunu",
    icon: "♍",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/xu-nu.htm"
  },
  {
    name: "Thiên Bình – Aries (23/9 - 22/10)",
    id: "thienbinh",
    icon: "♎",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/thien-binh.htm"
  },
  {
    name: "Bọ Cạp – Scorpio (23/10 - 21/11)",
    id: "bocap",
    icon: "♏",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/bo-cap.htm"
  },
  {
    name: "Nhân Mã – Sagittarius (22/11 - 21/12)",
    id: "nhanma",
    icon: "♐",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/nhan-ma.htm"
  },
  {
    name: "Ma Kết – Capricorn (22/12 - 19/1)",
    id: "maket",
    icon: "♑",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/ma-ket.htm"
  },
  {
    name: "Bảo Bình – Aquarius (20/1 - 18/2)",
    id: "baobinh",
    icon: "♒",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/bao-binh.htm"
  },
  {
    name: "Song Ngư – Pisces (19/2 - 20/3)",
    id: "songngu",
    icon: "♓",
    link: "https://www.lasotuvi365.com/tu-vi/hom-nay/song-ngu.htm"
  }
]

export default function Horoscope({ setScreen } : ISwitchScreenAction) {

  interface IListItem {
    id?: string,
    name: string,
    icon: string,
    link: string
  }

  interface IHoroscope {
    summary: string, 
    overall: {name: string, star: number, summary: string}[]
  }

  const [list, setList] =useState<IListItem[]>([])
  const [loading, setLoading] = useState(true);
  const [showToday, setShowToday] = useState(false);
  const [showTomorrow, setShowTomorrow] = useState(false);
  const [detailCung, setDetailCung] = useState<IListItem>();
  const [resultHoroscope, setResultHoroscope] = useState<IHoroscope>()
  const [error, setError] = useState<string | undefined>()
  const difContainer = useRef()

  const getDetails = async (item:IListItem) => {
    setLoading(true)
    try {
      const response = await fetch(item.link, { mode: "cors" }); // CORS cần được server cho phép
      const text = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      // Lấy nội dung cần hiển thị (ví dụ: <title>)
      const title = doc.querySelector("title")?.textContent || "Không tìm thấy title";
      const summaries = doc.getElementsByClassName('content-intro')
      let partWrong = ''
      const result : IHoroscope = {
        summary: '',
        overall: []
      }
      if (summaries && summaries.length > 0) {
        result.summary = summaries[0].textContent ?? ''
      } else {
        partWrong += 'summary'
      }

      // // Only get stars with title
      // const elementSummaryRatings = doc.getElementsByClassName('summary-rating')
      // if (elementSummaryRatings && elementSummaryRatings.length > 0) {
      //   const elementSummaryRating = elementSummaryRatings[0]
      //   const ratingCards = elementSummaryRating.getElementsByClassName('summary-card')
        
      //   if (ratingCards && ratingCards.length > 0) {
      //     for (let index = 0; index < ratingCards.length; index++) {
      //       const element = ratingCards[index];
      //       const nameElement = element.getElementsByClassName('summary-title')
      //       const starElement = element.getElementsByClassName('staron')
      //       let name = ''
      //       let star = 0
      //       if (nameElement && nameElement.length > 0) {
      //         name = nameElement[0].textContent ?? ''
      //       } else {
      //         partWrong += 'rating_card_title'
      //       }

      //       if (starElement && starElement.length > 0) {
      //         star = `${starElement[0].textContent}`.length
      //       } else {
      //         partWrong += 'rating_card_star'
      //       }
      //       const rating = {
      //         name: name,
      //         star: star
      //       }
      //       console.log(rating)
      //       result.overall.push(rating)
      //     }
      //   } else {
      //     partWrong += 'rating_card'
      //   }
      // } else {
      //   partWrong += 'rating'
      // }

      const sectionElements = doc.getElementsByClassName('horoscope-section')

      if (sectionElements && sectionElements.length > 0) {
        for (let index = 0; index < sectionElements.length; index++) {
          const element = sectionElements[index];
          const headerElements = element.getElementsByClassName('horoscope-header')
          if (headerElements && headerElements.length > 0) {
            const headerElement = headerElements[0]
            const h2Element = headerElement.querySelector('h2')
            if (h2Element) {
              const name = h2Element.textContent ?? ''
              let star = 0
              let desc = ''
              const starElement = headerElement.getElementsByClassName('staron')
              if (starElement && starElement.length > 0) {
                star = `${starElement[0].textContent}`.length
              } else {
                partWrong += 'section-header-star'
              }
              const summaryDetailElement = element.querySelector('p')
              if (summaryDetailElement) {
                desc = summaryDetailElement.textContent ?? ''
              } else {
                partWrong += 'section-summary'
              }
              const item = {
                name,
                star,
                summary: desc
              }
              result.overall.push(item)
            } else {
              partWrong += 'section-header-h2'
            }
          } else {
            partWrong += 'section-header'
          }
        }
      } else {
        partWrong += 'sections';
      }

      console.log(result)
      console.log('Part wrong:', partWrong)
      if (partWrong === '') {
        setError(undefined)
        setResultHoroscope(result)
        sendTelegramMessage(TELEGRAM_GROUP_ID, TELEGRAM_TOKEN_HOROSCOPE, 'Tử vi cho ' + item?.name + ' - ' + result.summary)
      } else {
        setError('Lấy thông tin tử vi ' + item?.name + ' không thành công, hãy thử lại sau nhé!')
        sendTelegramMessage(TELEGRAM_GROUP_ID, TELEGRAM_TOKEN_HOROSCOPE, 'Tử vi lỗi ' + partWrong + ' của ' + item?.name)
      }
      setLoading(false)
    } catch (error) {
      console.error("Lỗi khi fetch hoặc parse:", error);
      console.log("Không thể tải nội dung");
    }
  }

  const renderList = () => {
    return <div className="grid-container">
    {dataListHoroscope.map((item, index) => (
      <div key={index} className="grid-item" onClick={()=> {
        // Toast.show("Chi tiết Cung hoàng đạo theo ngày sẽ sớm có!")
        setDetailCung(item);
        setShowToday(true);
        getDetails(item);
      }}>
        <div>{item.name}</div>
        <div style={{marginTop: 4, fontSize: 36}}>{item.icon}</div>
      </div>
    ))}
  </div>
  }

  const renderResultHoroscope = () => {
    const ele = document.getElementById('divContainer')
    let height = '100%'
    if (ele?.clientHeight) {
      height = `${ele.clientHeight - 86}px`
      console.log(height, ele.clientHeight)
    }
    return (
      <div style={{overflow: 'scroll', overflowY: 'scroll', height:height, display: 'flex', flexDirection: 'column'}}>
        <div className="max-w-xl mx-auto p-4">
      <div className="grid gap-4">
          <div><h5 className="text-lg font-semibold mb-2" style={{fontSize: 18, lineHeight: 1.5}}>Tổng quan ngày {moment().format('DD/MM/yyyy')}: <br/> {resultHoroscope?.summary}</h5></div>
        {resultHoroscope?.overall.map((num, index) => (
          <div
            key={num.name+"index"}
            className="border border-gray-300 shadow-md rounded-2xl p-4 bg-white hover:shadow-lg transition-shadow duration-300"
          >
            <div style={{color: '#525252'}}>{num.name}: {num.star}/5</div>
            <span className="mb-2" style={{fontSize: 14}}>{num.summary}</span>
            <br/>
            <br/>
          </div>
        ))}
      </div>
    </div>
        <div style={{textAlign: 'right', fontSize: 12, color: 'gray'}}>Nguồn - lasotuvi365</div>
      </div>
    )
  }

  const renderDetails = () => {
    let title = ''
    const cung = dataListHoroscope.find(item => item.id === detailCung?.id)
    title = `Tử vi hôm nay của ${cung?.name}`
    return <div   id="divContainer" ref={difContainer.current} style={{position: 'absolute', left: 0, right: 0, bottom: 0, top: 0}}>
      <NavBar style={{backgroundColor: 'white', whiteSpace: 'nowrap', overflow: 'hidden' }} onBack={()=> {
             setShowToday(false)
             setShowTomorrow(false)
             setDetailCung(undefined)
             setLoading(false);
      }} >{title}</NavBar>
      <div  style={{marginTop: 0}}>
        <div style={{
          display: 'flex', 
          flexDirection: 'column', 
          borderColor: 'rgba(16, 20, 27, 0.08)', 
          borderStyle: 'solid', 
          borderWidth: 1, 
          marginTop: 8,
          marginBottom: 16,
          marginLeft: 16, marginRight: 16,
          paddingLeft: 16, paddingRight: 16,
          backgroundColor: 'white',
          borderRadius: 16}}>

          {loading && <LoadingView msg={'Đang lấy dữ liệu tử vi'}/>}
          {!loading && Boolean(error) && error}
          {!loading && resultHoroscope && renderResultHoroscope()}

        </div>
      </div>
    </div>
  }

  return (
    <div>
      <NavBar style={{}} onBack={()=> {
              // setScreen(APPLICATION_SCREEN.JOIN_GAME_INPUT)
      }} >Tử vi 12 Cung Hoàng Đạo hôm nay</NavBar>
      <div  style={{marginTop: 8}}>
      <div style={{
        display: 'flex', 
        flexDirection: 'column', 
        borderColor: 'rgba(16, 20, 27, 0.08)', 
        borderStyle: 'solid', 
        borderWidth: 1, 
        paddingBottom: 16,
        borderRadius: 16}}>
          
        {renderList()}
      </div>
      </div>
      {/* <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
        /> */}
        <Mask visible={showToday || showTomorrow} onMaskClick={()=> {
          setShowToday(false);
          console.log('ckl')
          setShowTomorrow(false);
        }}>
          {renderDetails()}
        </Mask>
    </div>
  );
}
